<qima-button-icon
  [qimaButtonIconStyle]="buttonIconStyles.TERTIARY_UTILITY"
  [qimaButtonIconName]="iconNames.SEARCH"
  (qimaButtonIconClick)="displaySearchBar()"
  class="search-icon"
  [ngClass]="{ 'search-icon--displayed': !isSearchBarDisplayed }"
></qima-button-icon>

<qima-input-search-select
  [formControl]="control"
  [qimaInputSearchSelectHasClearButton]="false"
  (qimaInputSearchSelectSearchInputChange)="search($event)"
  [qimaInputSearchSelectIsLoading]="isLoading"
  (focusout)="hideSearchBar()"
  class="search-bar"
  [ngClass]="{ 'search-bar--displayed': isSearchBarDisplayed }"
  data-cy="quick-search-searchbar"
>
  @if (searchTerm$ | async) {
    <qima-menu [qimaMenuMaxHeight]="500">
      @for (result of quickSearchResults$ | async; track result.id) {
        <qima-menu-item-ice-cube
          [qimaMenuItemIceCubeIconName]="typesConfigs[result.type].icon"
          [qimaMenuItemIceCubeIconStyle]="typesConfigs[result.type].color"
          [qimaMenuItemIceCubeLabel]="result.title"
          [qimaMenuItemIceCubeValue]="result"
          (qimaMenuItemIceCubeClick)="selectQuickSearchResult(result)"
        >
        </qima-menu-item-ice-cube>
      }
    </qima-menu>
  }
</qima-input-search-select>
